<template>
  <div class="container">
    <div v-for="item,index in bonusGroupList" :key="item.groupKey" class="bonus-item" :class="{'padding-20' : type === 'edit'}">
      <RegionBeesBonusBeerItem ref="BonusBeerOnlineItem" :bonusBeerInfo="item" :monthList="monthList" :type="type" :themeStatus="themeStatus" :handleType='handleType'>
        <span slot="groupName">奖励组合{{index + 1}}</span>
        <div v-if="type !== 'show'">
          <el-button type="primary" v-if="index === bonusGroupList.length - 1" plain @click="addBonusGroup">新增</el-button>
          <el-button type="danger" v-if=" bonusGroupList.length !== 1 && (!item.groupId || themeStatus < 200)" plain @click="removeBonusGroup(index)">删除</el-button>
        </div>
      </RegionBeesBonusBeerItem>
    </div>
  </div>
</template>

<script>

import RegionBeesBonusBeerItem from '@/views/trade/perfect2022/components/region-bees-bonus-beer-item.vue'
export default {
  props: {
    monthList: {
      type: Array,
      default: () => {
        return []
      }
    },
    dataList: {
      type: Array,
      default: () => {
        return []
      }
    },
    type: {
      type: String,
      default: 'edit'
    },
    themeStatus: {
      default: 0
    },
    handleType: {
      type: String,
      default: ''
    }
  },
  components: {
    RegionBeesBonusBeerItem
  },
  watch: {
    dataList () {
      this.bonusGroupList = JSON.parse(JSON.stringify(this.dataList)).map(item => {
        item.bonusDetail = JSON.parse(item.bonusDetail)
        item.groupKey = this.groupKey++
        return item
      })
      // console.log(this.bonusGroupList)
    }
  },
  created () {
    if (this.dataList.length) {
      this.bonusGroupList = JSON.parse(JSON.stringify(this.dataList)).map(item => {
        item.bonusDetail = JSON.parse(item.bonusDetail)
        item.groupKey = this.groupKey++
        return item
      })
    }
  },
  data () {
    return {
      bonusGroupList: [
        {
          bonusType: '04',
          groupName: '',
          bonusDetail: [],
          groupKey: 1
        }
      ],
      combinationIndex: '',
      skuIndex: '',
      groupKey: 0
    }
  },
  methods: {
    addBonusGroup () {
      this.bonusGroupList.push({
        bonusType: '04',
        groupName: '',
        bonusDetail: [],
        groupKey: this.groupKey++ // 用作v-for key 无实际意义
      })
    },
    removeBonusGroup (index) {
      this.bonusGroupList.splice(index, 1)
    },
    getValue () {
      let list = []
      for (let i = 0; i < this.$refs.BonusBeerOnlineItem.length; i++) {
        list.push(this.$refs.BonusBeerOnlineItem[i].bonusInfo)
      }
      return list
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
}
.bonus-item {
  padding: 20px 0px;
  border-bottom: 1px solid #c1c1c1;
}
.padding-20{
  // padding: 20px 20px;
  padding-left: 20px;
  padding-right: 20px;
}
</style>
